import React, { useState, useRef, useEffect } from "react";
import "./Playlist.css";

const Playlist = ({ data, onViewSongs, onDelete, onEdit, onShare, isOwner = true, isShared = false }) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  // Cerrar menú al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  const handleMenuClick = (e) => {
    e.stopPropagation();
    setShowMenu(!showMenu);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    setShowMenu(false);
    if (onEdit) onEdit(data);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    setShowMenu(false);
    if (onDelete) onDelete(data);
  };

  const handleShare = (e) => {
    e.stopPropagation();
    setShowMenu(false);
    if (onShare) onShare(data);
  };

  const handleCardClick = () => {
    if (onViewSongs) {
      onViewSongs(data);
    }
  };

  // Usar la portada de la primera canción o la imagen de la playlist
  const playlistImage = data.songs?.[0]?.image || data.image;

  return (
    <div className="playlist-card" onClick={handleCardClick}>
      <div className="playlist-image-container">
        {playlistImage ? (
          <img src={playlistImage} alt={data.name} className="playlist-image" />
        ) : (
          <div className="playlist-image-placeholder">
            <div className="playlist-icon-text">{data.name.charAt(0).toUpperCase()}</div>
          </div>
        )}
      </div>

      <div className="playlist-info">
        <h3 className="playlist-name">{data.name}</h3>
        {data.description && (
          <p className="playlist-description">{data.description}</p>
        )}
        <div className="playlist-meta">
          <span className="playlist-song-count">
            {data.songs?.length || 0} {data.songs?.length === 1 ? "canción" : "canciones"}
          </span>
          {isShared ? (
            <span className="playlist-shared-badge">
               Compartida{data.owner?.username ? ` por ${data.owner.username}` : data.owner?.email ? ` por ${data.owner.email.split('@')[0]}` : ''}
            </span>
          ) : (
            <span className={`playlist-visibility ${data.isPublic ? "public" : "private"}`}>
              {data.isPublic ? "Pública" : "Privada"}
            </span>
          )}
        </div>
        {isShared && data.permission && (
          <div className="playlist-permission-badge">
            {data.permission === 'comment' && 'Puedes comentar'}
            {data.permission === 'collaborate' && 'Puedes colaborar'}
          </div>
        )}
      </div>

      {/* Menú de tres puntos */}
      <div className="playlist-menu-container" ref={menuRef}>
        <button
          className="playlist-menu-button"
          onClick={handleMenuClick}
        >
          ...
        </button>

        {showMenu && (
          <div className="playlist-dropdown-menu">
            {isOwner ? (
              <>
                {onEdit && (
                  <button className="menu-item" onClick={handleEdit}>
                    Editar
                  </button>
                )}
                {onShare && (
                  <button className="menu-item" onClick={handleShare}>
                    Compartir
                  </button>
                )}
                <button className="menu-item menu-item-danger" onClick={handleDelete}>
                  Eliminar
                </button>
              </>
            ) : (
              <>
                {data.permission === 'collaborate' && onEdit && (
                  <button className="menu-item" onClick={handleEdit}>
                    Editar
                  </button>
                )}
                <button className="menu-item menu-item-warning" onClick={handleDelete}>
                  Desvincular
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Playlist;